// src/components/RefreshButton/RefreshButton.jsx
import React, { useState } from 'react';
import './RefreshButton.css';

const RefreshButton = ({ 
  onRefresh, 
  loading = false, 
  disabled = false,
  size = 'medium',
  variant = 'primary',
  showText = true,
  className = ''
}) => {
  const [isSpinning, setIsSpinning] = useState(false);

  const handleClick = async () => {
    if (disabled || loading) return;
    
    setIsSpinning(true);
    
    try {
      await onRefresh();
    } finally {
      // Keep spinning animation for a bit longer for visual feedback
      setTimeout(() => {
        setIsSpinning(false);
      }, 500);
    }
  };

  const buttonClasses = [
    'refresh-button',
    `refresh-button--${size}`,
    `refresh-button--${variant}`,
    loading || isSpinning ? 'refresh-button--loading' : '',
    disabled ? 'refresh-button--disabled' : '',
    !showText ? 'refresh-button--no-text' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      title={showText ? 'Refresh data' : 'Refresh'}
    >
      <svg 
        className={`refresh-icon ${isSpinning || loading ? 'refresh-icon--spinning' : ''}`}
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M1 4V10H7" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M23 20V14H17" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
      {showText && (
        <span className="refresh-text">
          {loading || isSpinning ? 'Refreshing...' : 'Refresh'}
        </span>
      )}
    </button>
  );
};

export default RefreshButton;
